import { FormElements } from "lib/api/types";
import React from "react";
import GroupItem from "./GroupItem";

interface Props {
	groups: number[][];
	elements: FormElements;
	traversal: string[];
	fullWidth: boolean;
	fid: string;
}

const Group = ({ groups, elements, traversal, fullWidth, fid }: Props) => {
	return (
		<>
			{groups.map((group, i) => (
				<GroupItem
					group={group}
					elements={elements}
					traversal={traversal}
					fullWidth={fullWidth}
					fid={fid}
					key={i}
				/>
			))}
		</>
	);
};

export default Group;
